<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() { // 父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true, // 控制视图是否显示的变量
      isuploadFile: false, // 跟踪文件上传状态
      isUpdateList: false, // 跟踪批量创建完成之后需要更新列表
      isHistory: false // 跟踪批量上传历史抽屉是否打开，关闭打开的时候需要关闭
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false // 先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true // 再打开
      })
    }
  }
}
</script>

<style lang="scss">
  #app{
    font-family: PingFangSC-Regular;
    font-size: 14px;
  }
</style>
